import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  CONTRACT_BUY_INTL_PREFIX,
  GENERAL_ERROR_KEY,
  MANUAL_PRICE_NAME,
  MANUAL_RATE_NAME,
  MW_ASKING_NAME,
  MWH_ASKING_NAME,
  PERCENT_ASKING_NAME,
  PRODUCT_NAME,
  // RELEASING_CHECKBOX,
} from './ContractBuy';
import styled from 'styled-components';
import { COLORS_ERROR, GRAPH_VOLUME_COLOR } from '../../../constants/colors';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info_outline.svg';
import TextField from '@material-ui/core/TextField';
// import Checkbox from '@material-ui/core/Checkbox';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import { BuyVolumeInputField } from './BuyVolumeInputField';
import PropTypes from 'prop-types';
import { BuyInputDivider } from './BuyInputDivider';
import Button from '@material-ui/core/Button';
import userRoles from '../../../constants/userRoles';
import CustomCheckBox from '../../../components/CustomizedComponents/CustomCheckBox';

const Layout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .inner_box {
    max-width: 450px;
    .productsInfo {
      display: flex;
      align-items: center;
      border-radius: 4px;
      background-color: ${GRAPH_VOLUME_COLOR};
      color: rgba(0, 0, 0, 0.6);
      font-size: 13.18px;
      font-weight: 500;
      letter-spacing: 0.4px;
      line-height: 16px;
      width: 100%;
      height: 36px;
      margin-bottom: 20px;
      > svg {
        margin-left: 16px;
        margin-right: 8px;
      }
    }
    .product_select {
      width: 100%;
      margin-bottom: 10px;
    }
    .release_checkbox {
      margin-bottom: 34px;
    }
    .volumes_layout {
      display: flex;
      width: 100%;
      .buy_divider {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
      }
    }
    .errorBox {
      min-height: 32px;
      color: ${COLORS_ERROR};
      font-size: 13.18px;
      letter-spacing: 0.4px;
      line-height: 16px;
      margin-top: 7px;
      margin-left: 14px;
    }
    .fillVolumeButton {
      margin-top: 14px;
    }
  }
`;

export const BuyInputs = ({
  register,
  onNumberBuyInputChange,
  products,
  onProductChange,
  // onReleaseCheckboxChange,
  className,
  product,
  errors,
  onFillVolumeClicked,
  remainingPurchaseCount,
  role,
  // isSaleAvailable,
  isFix,
  sendNotification,
  setSendNotification,
}) => {
  const TRANSLATION_BASE = isFix ? 'app.contract.sale' : 'app.contract.purchase';
  const intl = useIntl();
  const productsNotLoaded = !products;
  const productNotSelected = !product;
  return (
    <Layout className={className}>
      <div className={'inner_box'}>
        <div className={'productsInfo'}>
          <InfoIcon />
          {products &&
            remainingPurchaseCount >= 0 &&
            intl.formatMessage(
              {
                id: `${TRANSLATION_BASE}.stepsCount`,
              },
              {
                productNumber: remainingPurchaseCount,
              },
            )}
          {products &&
            remainingPurchaseCount < 0 &&
            intl.formatMessage({
              id: `${TRANSLATION_BASE}.stepsCount_negative`,
            })}
        </div>
        <TextField
          className={'product_select'}
          inputRef={register()}
          name={PRODUCT_NAME}
          select
          label={intl.formatMessage({ id: `${CONTRACT_BUY_INTL_PREFIX}.product` })}
          SelectProps={{
            native: true,
          }}
          disabled={productsNotLoaded}
          variant="outlined"
          onChange={(event) => onProductChange(event.target.value)}>
          <option key={`product-empty`} value={' '} />
          {products &&
            products.map((mapProduct, index) => (
              <option key={`product-${index}`} value={mapProduct.id}>
                {mapProduct.name}
              </option>
            ))}
        </TextField>
        {/* {isSaleAvailable && (
          <FormControlLabel
            className={'release_checkbox'}
            control={<Checkbox name={RELEASING_CHECKBOX} inputRef={register()} onChange={onReleaseCheckboxChange} />}
            label="Odprodej"
          />
        )} */}
        <div className={'volumes_layout'}>
          <BuyVolumeInputField
            register={register}
            disabled={productNotSelected}
            name={MWH_ASKING_NAME}
            onBuyInputChange={onNumberBuyInputChange}
            errors={errors}
          />
          <BuyInputDivider />
          <BuyVolumeInputField
            register={register}
            disabled={productNotSelected}
            name={MW_ASKING_NAME}
            onBuyInputChange={onNumberBuyInputChange}
            errors={errors}
          />
          <BuyInputDivider />
          <BuyVolumeInputField
            register={register}
            disabled={productNotSelected}
            name={PERCENT_ASKING_NAME}
            onBuyInputChange={onNumberBuyInputChange}
            errors={errors}
          />
        </div>
        {role === userRoles.ADMIN && (
          <>
            <div className={'volumes_layout'} style={{ padding: '20px 0' }}>
              <BuyVolumeInputField
                register={register}
                disabled={productNotSelected}
                name={MANUAL_PRICE_NAME}
                onBuyInputChange={onNumberBuyInputChange}
                errors={errors}
              />
              <BuyInputDivider />
              <BuyVolumeInputField
                register={register}
                disabled={productNotSelected}
                name={MANUAL_RATE_NAME}
                onBuyInputChange={onNumberBuyInputChange}
                errors={errors}
              />
            </div>
            <div>
              <CustomCheckBox
                checked={sendNotification}
                disabled={false}
                onChange={(event) => {
                  setSendNotification(event.target.checked);
                }}
              />
              {
                intl.formatMessage({
                  id: `${CONTRACT_BUY_INTL_PREFIX}.sendNotification`,
                })}
            </div>
          </>
        )}
        <div className={'errorBox'}>{errors[GENERAL_ERROR_KEY]}</div>
        <Button color="primary" variant="outlined" className={'fillVolumeButton'} disabled={productNotSelected} onClick={onFillVolumeClicked}>
          <FormattedMessage id={`${CONTRACT_BUY_INTL_PREFIX}.fillVolumeButton`} />
        </Button>
      </div>
    </Layout>
  );
};

BuyInputs.propTypes = {
  register: PropTypes.func.isRequired,
  onNumberBuyInputChange: PropTypes.func.isRequired,
  onFillVolumeClicked: PropTypes.func.isRequired,
  onProductChange: PropTypes.func.isRequired,
  onReleaseCheckboxChange: PropTypes.func.isRequired,
  setSendNotification: PropTypes.func,
  className: PropTypes.string,
  products: PropTypes.array,
  product: PropTypes.object,
  errors: PropTypes.object,
  remainingPurchaseCount: PropTypes.number,
  role: PropTypes.string,
  isSaleAvailable: PropTypes.bool,
  isFix: PropTypes.bool,
  sendNotification: PropTypes.bool,
};
